// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__Ei6Qw","left":"InfoRow_left__2hLzV"};